module.exports = __webpack_public_path__ + "img/part1.faf58396.png";